// TOUR_EXTRAS_2910 (GROK2 29/10): tour guiado na 1ª visita a um módulo Extras adicionado (switch private/TOUR_EXTRAS_2910_OFF).
// "Visto" no backend (/api/aurax/tour-extras) + localStorage. Passo sem elemento na tela é pulado. Botão "?" refaz o tour.
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';
import { useAuraxFlags } from '../lib/auraxFlags';
import './TourExtras2910.css';

// a: lista de seletores (o 1º que existir e estiver visível vale) ou texto t: de botão/título
const TOURS = {
  whatsapp: { paths: ['/connections'], steps: [
    { m: 'Aqui você conecta o WhatsApp da sua revenda ao painel.' },
    { a: ['[data-testid="new-connection-btn"]'], m: 'Toque aqui para conectar um número pelo QR code.' },
    { a: ['[aria-label="Verificar serviço WhatsApp"]'], t: 'Verificar novamente', m: 'Confira se o número está conectado ou caiu.' },
    { a: ['[aria-label="Fila de mensagens do WhatsApp"]'], m: 'Fila protegida: mensagens esperam aqui se a conexão oscilar.' } ] },
  atendimentos: { paths: ['/atendimento', '/chats', '/contacts', '/funnel'], steps: [
    { m: 'Central de Atendimentos: converse com clientes sem sair do painel.' },
    { a: ['.app-page-inner input', 'main input'], m: 'Cole a chave do seu robô aqui para abrir o chat.' },
    { t: 'Atendidos hoje', m: 'Acompanhe quantos clientes foram atendidos hoje e na semana.' },
    { t: 'Instâncias de WhatsApp', m: 'Seus números de atendimento aparecem aqui.' } ] },
  chatbot: { paths: ['/triggers/chatbot', '/aurax-ai'], steps: [
    { m: 'Monte fluxos automáticos que respondem seus clientes.' },
    { t: 'Meus fluxos', m: 'Seus roteiros ficam aqui. Comece por um modelo.' },
    { t: 'Abrir editor', m: 'Abra o editor para montar os blocos da conversa.' },
    { t: 'Conversas do bot', m: 'Veja o que o bot respondeu e o que passou para humano.' } ] },
  modelos: { paths: ['/notification-templates'], steps: [
    { m: 'Edite os textos dos avisos automáticos da sua revenda.' },
    { a: ['[aria-label="Buscar modelo de notificação"]'], m: 'Busque o aviso que quer mudar (vencimento, renovação…).' },
    { a: ['[aria-label="Lista de mensagens"]'], m: 'Escolha um modelo da lista para editar.' },
    { a: ['[aria-label="Variáveis"]'], t: 'Inserir variável', m: 'Variáveis como usuário e vencimento entram sozinhas no envio.' } ] },
  gatilhos: { paths: ['/triggers'], steps: [
    { m: 'Gatilhos respondem sozinhos quando o cliente manda uma palavra.' },
    { a: ['[data-testid="add-trigger-btn"]', '[data-testid="empty-create-trigger"]'], m: 'Crie um gatilho, por exemplo com a palavra "teste".' },
    { a: ['[data-testid="add-quick-reply-btn"]'], m: 'Respostas rápidas para os atendentes usarem.' },
    { a: ['[aria-label="Pré-visualização WhatsApp"]'], m: 'Veja como a mensagem chega no WhatsApp.' } ] },
  recuperacao: { paths: ['/recuperacao'], steps: [
    { m: 'Campanhas para trazer de volta clientes vencidos.' },
    { a: ['[data-testid="recuperacao-new"]'], m: 'Crie uma campanha nova aqui.' },
    { a: ['[aria-label="Resumo das campanhas"]'], m: 'Resumo de entregas e falhas das campanhas.' },
    { a: ['[aria-label="Buscar campanha"]'], m: 'Encontre uma campanha e abra o relatório.' } ] },
  disparo: { paths: ['/mass-dispatch'], steps: [
    { m: 'O disparo em massa é feito pelas campanhas da Recuperação.' },
    { a: ['[data-testid="recuperacao-new"]'], m: 'Crie a campanha e escolha os contatos.' },
    { a: ['[aria-label="Campanhas de recuperação"]', '[aria-label="Visão de campanhas"]'], m: 'Acompanhe o progresso de cada envio aqui.' } ] },
  equipe: { paths: ['/team'], steps: [
    { m: 'Cadastre atendentes com acesso, comissão e metas.' },
    { a: ['[data-testid="add-user-btn"]'], m: 'Adicione um atendente aqui.' },
    { t: 'Criar perfis padrão', m: 'Perfis prontos para liberar só o que cada um precisa.' },
    { a: ['[aria-label="Seções da equipe"]'], m: 'Troque entre usuários, comissões e metas.' } ] },
  reunioes: { paths: ['/reunioes'], steps: [
    { m: 'Crie salas com link para falar com cliente ou revenda.' },
    { a: ['[title="Criar reunião"]'], t: 'Criar reunião', m: 'Crie uma reunião com assunto, convidado e duração.' },
    { a: ['[aria-label="Buscar reunião"]'], m: 'Busque por assunto, convidado ou contato.' },
    { a: ['[aria-label="Lista de reuniões"]'], m: 'Suas reuniões aparecem aqui.' } ] },
  materiais: { paths: ['/materiais'], steps: [
    { m: 'Conteúdos oficiais da central para você divulgar.' },
    { a: ['input[placeholder^="Buscar por título"]'], m: 'Busque por título, tag ou texto.' },
    { t: 'Todas as categorias', m: 'Filtre pela categoria do material.' },
    { a: ['[aria-label="Resumo da biblioteca"]'], m: 'Resumo do que está publicado.' } ] },
};
const LS = 'aurax_tour_seen_2910';
const lsGet = () => { try { return JSON.parse(localStorage.getItem(LS) || '[]'); } catch (_) { return []; } };
const lsAdd = (m) => { try { localStorage.setItem(LS, JSON.stringify([...new Set([...lsGet(), m])])); } catch (_) { /* noop */ } };

function modFor(path) {
  let best = null; let len = 0;
  Object.entries(TOURS).forEach(([k, v]) => v.paths.forEach((p) => {
    if ((path === p || path.startsWith(p + '/')) && p.length > len) { best = k; len = p.length; }
  }));
  return best;
}
const vis = (el) => { if (!el) return false; const r = el.getBoundingClientRect(); return r.width > 4 && r.height > 4; };
function findEl(s) {
  for (const q of s.a || []) { const el = [...document.querySelectorAll(q)].find(vis); if (el) return el; }
  if (s.t) {
    const el = [...document.querySelectorAll('button,a,h1,h2,h3,h4,label,[role=tab],span,p')]
      .find((e) => vis(e) && (e.innerText || '').trim().startsWith(s.t) && (e.innerText || '').length < 80);
    if (el) return el.closest('button,a,[role=tab]') || el;
  }
  return null;
}

export default function TourExtras2910() {
  const flags = useAuraxFlags();
  const { pathname } = useLocation();
  const [seen, setSeen] = useState(null);
  const [run, setRun] = useState(null); // { mod, steps:[{el,m}], i }
  const [rect, setRect] = useState(null);
  const on = !!flags?.tour_extras_2910;
  const mod = on ? modFor(pathname) : null;
  const added = (flags?.extras_added_2910 || []).includes(mod);

  useEffect(() => {
    if (!on) return;
    axios.get(`${API_BASE_URL}/api/aurax/tour-extras`, { withCredentials: true })
      .then(({ data }) => setSeen([...new Set([...(data?.seen || []), ...lsGet()])])).catch(() => setSeen(lsGet()));
  }, [on]);

  const start = useCallback((m) => {
    const steps = TOURS[m].steps.map((s) => ({ m: s.m, el: s.a || s.t ? findEl(s) : 'center' }))
      .filter((s) => s.el);
    if (steps.length) setRun({ mod: m, steps, i: 0 });
  }, []);

  useEffect(() => {
    if (!mod || !added || !seen || seen.includes(mod) || run) return undefined;
    const t = setTimeout(() => start(mod), 1400);
    return () => clearTimeout(t);
  }, [mod, added, seen, run, start]);

  useEffect(() => { setRun(null); }, [pathname]);

  const cur = run && run.steps[run.i];
  useLayoutEffect(() => {
    if (!cur || cur.el === 'center') { setRect(null); return undefined; }
    cur.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const upd = () => { const r = cur.el.getBoundingClientRect(); setRect({ x: r.left - 6, y: r.top - 6, w: r.width + 12, h: r.height + 12 }); };
    upd(); const t = setTimeout(upd, 350);
    window.addEventListener('resize', upd); window.addEventListener('scroll', upd, true);
    return () => { clearTimeout(t); window.removeEventListener('resize', upd); window.removeEventListener('scroll', upd, true); };
  }, [cur]);

  const finish = () => {
    const m = run?.mod; setRun(null);
    if (!m) return;
    lsAdd(m); setSeen((s) => [...new Set([...(s || []), m])]);
    axios.put(`${API_BASE_URL}/api/aurax/tour-extras`, { module: m }, { withCredentials: true }).catch(() => {});
  };

  if (!mod || !added) return null;
  const helpBtn = <button type="button" className="tx2910-help" aria-label="Ver tour desta página" title="Ver tour" onClick={() => start(mod)}>?</button>;
  if (!cur) return createPortal(helpBtn, document.body);

  const vw = window.innerWidth; const vh = window.innerHeight;
  const W = Math.min(320, vw - 24);
  let pos; let arrow = null;
  if (rect) {
    const below = rect.y + rect.h + 170 < vh || rect.y < 180;
    const left = Math.max(12, Math.min(vw - W - 12, rect.x + rect.w / 2 - W / 2));
    pos = below ? { top: Math.min(vh - 160, rect.y + rect.h + 14), left } : { top: Math.max(12, rect.y - 14), left, transform: 'translateY(-100%)' };
    arrow = { left: Math.max(14, Math.min(W - 26, rect.x + rect.w / 2 - left - 6)), dir: below ? 'up' : 'down' };
  } else pos = { top: '50%', left: '50%', transform: 'translate(-50%,-50%)' };
  const last = run.i === run.steps.length - 1;
  return createPortal(
    <div className="tx2910" role="dialog" aria-modal="true" aria-label="Tour guiado" data-tour-extras-2910>
      {rect ? <div className="tx2910-spot" style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }} />
        : <div className="tx2910-dim" />}
      <div className="tx2910-pop" style={{ ...pos, width: W }}>
        {arrow ? <i className={`tx2910-arw ${arrow.dir}`} style={{ left: arrow.left }} /> : null}
        <div className="tx2910-dots">{run.steps.map((_, k) => <b key={k} className={k === run.i ? 'on' : ''} />)}<span>{run.i + 1}/{run.steps.length}</span></div>
        <p>{cur.m}</p>
        <div className="tx2910-act">
          {!last ? <button type="button" className="tx2910-skip" onClick={finish}>Pular</button> : <span />}
          <button type="button" className="tx2910-next" onClick={() => (last ? finish() : setRun({ ...run, i: run.i + 1 }))}>{last ? 'Concluir' : 'Próximo'}</button>
        </div>
      </div>
    </div>, document.body);
}
